import { render, staticRenderFns } from "./EstudoTable.vue?vue&type=template&id=27068557&scoped=true&"
import script from "./EstudoTable.vue?vue&type=script&lang=js&"
export * from "./EstudoTable.vue?vue&type=script&lang=js&"
import style0 from "./EstudoTable.vue?vue&type=style&index=0&id=27068557&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27068557",
  null
  
)

export default component.exports